/** The single transient message strip at the bottom of the screen. */
import { useApp } from '../store/AppContext.jsx';

export default function Toast() {
  const { toastMsg } = useApp();
  return <div className={`toast${toastMsg ? ' show' : ''}`}>{toastMsg}</div>;
}
